/**
 * product-financing-cta.js
 * CTA « Financement à partir de X €/mois » de la fiche produit — deux exemplaires rendus
 * côte à côte (`.xs-hidden` desktop / `.md-hidden` mobile, cf. product-template.liquid).
 *
 * Il pointait vers #product-financing-options, ancre qui n'est plus rendue depuis que le
 * bloc financement est masqué par défaut (2026-07-29) : le clic était mort. Le clic est
 * désormais proxifié vers le déclencheur `.greenleaze-button-product`, qui ouvre la modale
 * location — MÊME patron que le bandeau LLD mobile (assets/lld-header-banner-price.js:56).
 *
 * Pourquoi proxifier plutôt que reproduire ici la cascade openRentalFlow →
 * GreenleazeLocationModal → iframe : cette cascade vit déjà dans le listener de
 * `.greenleaze-button-product` (snippets/greenleaze-abonnement-product.liquid). La
 * proxifier garantit un comportement identique au bouton « Louer » et fait hériter ce CTA
 * de la refonte de la modale location sans une ligne de plus ici — au lieu d'une 3e copie
 * de la cascade à maintenir en parallèle.
 *
 * Le href reste le fallback : sans bouton GreenLeaze rendu (produit non louable), la
 * navigation native reprend la main, comportement d'avant.
 *
 * ⚠️ `preventDefault()` n'arrête PAS la propagation : le listener de tracking
 * `click_financing_banner`, posé sur le conteneur `.financing-options-cta` par
 * product-template.liquid, reçoit bien l'événement par bouillonnement. Ne jamais le
 * remplacer par `stopPropagation()` — l'event serait perdu silencieusement.
 */
(function () {
  'use strict';
  var ctas = document.querySelectorAll('.financing-options-cta a');
  if (!ctas.length) return;

  ctas.forEach(function (cta) {
    cta.addEventListener('click', function (e) {
      var trigger = document.querySelector('.greenleaze-button-product');
      if (!trigger) return;
      e.preventDefault();
      trigger.click();
    });
  });
})();
